import { useAuthContext } from "@/contexts/AuthContext";

/**
 * Drop-in replacement for Clerk's useAuth() and useUser() hooks.
 */
export function useAuth() {
  const { user, token, isLoaded, isSignedIn, userId, logout, login, loginWithOtp, demoLogin, register } = useAuthContext();

  const getToken = async (): Promise<string | null> => {
    return token;
  };

  const signOut = async () => {
    await logout();
  };

  return {
    isLoaded,
    isSignedIn,
    userId,
    user,
    token,
    getToken,
    signOut,
    login,
    loginWithOtp,
    demoLogin,
    register,
  };
}

export function useUser() {
  const { user, isLoaded, isSignedIn } = useAuthContext();
  return {
    isLoaded,
    isSignedIn,
    user,
  };
}

export default useAuth;
